module.exports = __webpack_public_path__ + "static/media/backgroundCat3.733a43d1.jpg";